export const auditConstants = {
  FETCH_GLOBAL_AUDITS_LOADING: 'FETCH_GLOBAL_AUDITS_LOADING',
  FETCH_GLOBAL_AUDITS_SUCCESS: 'FETCH_GLOBAL_AUDITS_SUCCESS',
  FETCH_GLOBAL_AUDITS_ERROR: 'FETCH_GLOBAL_AUDITS_ERROR',
}
